// Class and jQuery | $ are global objects referenced by Enhancer.

// var validationMsg = require('../../i18n');
var locale = require('../../i18n');

var InputBase = Class.extend( {
    init: function( model, $p, zContext ) {
        this.__id = new Date().getTime();
        this.model = model;
        this.dataType = model.dataType;
        this.form = model.form;
        this.contextInputId = this.form.getWindowNo() + '-' + this.model.name;
        this.$container = $( '<div>' )
            .addClass( 'input-field' )
            .addClass( 'align-' + (model.textAlign || 'left'))
            .addClass( model.type )
            .appendTo( $p );

        this.$inp = this.create( model.inputOptions, this.$container );
        var that = this;

        if ( model.hidden ) {
            this.hide();
        }

        if ( model.disabled ) {
            this.disable();
        }

        if ( model.readonly ) {
            this.readonly( true );
        }
        if ( model.assistButton) {
            this.$container.addClass('assist');

            $('<span>').addClass('fa fa-list ui-state-default')
                .on('click', function(e) {
                    that.trig('Assist');
                })
                .hover(function() {
                    $(this).addClass('ui-state-hover');
                }, function() {
                    $(this).removeClass('ui-state-hover');
                })
                .appendTo(this.$container)
        }
        // bind check event
        if ( model.validationEvent !== 'none' ) {
            this.bindCheckEvent( model.validationEvent );
        }
        
        // if tip
        if ( model.tip ) {
            this.$container.hover( function() {
                that.showTips( model.tip, 'hover' );
            }, function() {
                that.closeTips();
            } );
        }
        // add event handlers
        this.eventHandlers = this.model.eventHandlers || {};
        for (var ename in this.eventHandlers) {
            try {
                this.eventHandlers[ename.toLowerCase()] = eval('(' + this.eventHandlers[ename] + ')');
            } catch(err) {
                console.error('Invalid event handler of ' + ename + ', caused by');
                console.error(err);
            }
        }
    },
    // This method only be called by form after this input object is created.
    initData: function( zContext, callback ) {
        var that = this;
        var model = this.model;
        if (model.source) {
            // load source and bind
            that.loadSource( function( data ) {
                // bind data
                that.bindData( data );

                // set default value
                if ( model.defaultValue ) {
                    that.setValue( model.defaultValue );
                }
                // set source data
                var sourceData = that.form.getFieldSourceData( that.model.name );
                if ( typeof sourceData !== 'undefined' ) {
                    that.setValue( sourceData );
                }

                // bind value
                if ( model.bindValue ) {
                    that.bindValue( zContext );
                }
                callback();
                if ( that.getValue() !== '' ) {
                    that.trig( 'Change' );
                }
            } );
        } else {
            // set default value
            if ( model.defaultValue ) {
                that.setValue( model.defaultValue );
            }
            // set source data
            var sourceData = that.form.getFieldSourceData( that.model.name );
            if ( typeof sourceData !== 'undefined' ) {
                that.setValue( sourceData );
            }
            // bind value
            if ( model.bindValue ) {
                that.bindValue( zContext );
            }
            callback();
            if ( this.getValue() !== '' ) {
                setTimeout(function() {
                    that.trig( 'Change' );
                }, 1);
            }
        }
    },
    create: function( inputOptions, $container ) {
        var that = this;
        var $inp = $( '<input>' )
            .attr('type', 'text')
            .attr('placeholder', inputOptions.placeholder);

        $container.append( $inp );
        $inp.on( 'keyup', function() {
            that.trig( 'Keyup' );
        } ).on( 'change', function() {
            that.trig( 'Change' );
        } ).on( 'blur', function() {
            that.trig( 'Blur' );
        } ).on( 'focus', function() {
            that.trig( 'Focus' );
        } );
        return $inp;
    },
    bindCheckEvent: function( eventName ) {
        if ( eventName === 'default' ) {
            eventName = 'blur';
        }
        var self = this;
        this.$inp.bind( eventName, function() {
            self.check();
        } );
    },
    loadSource: function( callback ) {

        var that = this, source = this.model.source;
        // if ( source ) {
        this.form.getSourceData( source.id, {
            format: 'default'
        }, function( data ) {
            if ( typeof callback === 'function' ) {
                callback( that.standardizeData(data), that );
            }
        } );
        // } else {
        //     if ( typeof callback === 'function' ) {
        //         callback( null, self );
        //     }
        // }
        return this;
    },

    // Make sure the dataset contains `displayName` and `value`
    standardizeData: function( data ) {
        data = data || [];
        var d, displayName, value, c1, c2, n;
        for ( var i = 0; i < data.length; i++ ) {
            d = data[i], n = 0;
            for ( var k in d ) {
                n++;
                d[ k.toUpperCase() ] = d[ k ];
                if (n === 1) {
                    c1 = d[k];
                }
                if (n === 2) {
                    c2 = d[k];
                    break;
                }
            }
            d.displayName = d['DISPLAYNAME'] || d['NAME'] || c1;
            d.value = d['VALUE'] || c2 || c1;
        }
        return data;
    },
    bindData: function( data ) {
        // console.log( data );
    },
    getValue: function() {
        return this.$inp.val();
    },
    getTypedValue: function() {
        var val = this.getValue();
        var type = this.model.dataType;
        if ( type === 'string' ) {
            val = val + '';
            if ( /\{0\}/.test(this.model.dataFormatter) ) {
                return this.model.dataFormatter.replace(/\{0\}/g, val);
            }
            return val;
        } else if ( type === 'number' ) {
            return parseFloat(val);
        } else if ( type === 'array' ) {
            if ( !val ) {
                return [];
            }
            if ( val instanceof Array ) {
                return val;
            }
            if ( typeof val === 'string' ) {
                return val.split(/\s*?,\s*?/)
            }
            return [val];
        }
        return val;
    },
    setValue: function( val ) {
        this.$inp.val( val );
        return this;
    },
    bindValue: function( zContext ) {

        var value = this.model.bindValue;
        if ( !value ) return false;
        value = zContext.val( value );
        if ( typeof value === 'undefined' ) {
            console.log( 'Warning: Can not "' + this.model.bindValue
                + '" from context! INPUTNAME: ' + this.model.name );
            return false;
        }
        this.setValue( value );
        return true;
    },
    affected: function( zContext ) {
        var lastVal = this.getValue();

        // clear data
        this.setValue('');

        // clear tips
        this.closeTips();

        var that = this;
        if ( that.model.source && that.model.source.params.length
             && !that.model.source.loadonce ) {
            
            that.loadSource( function(data) {
                that.bindData( data );

                // set source data
                var sourceData = that.form.getFieldSourceData( that.model.name );
                if ( typeof sourceData !== 'undefined' ) {
                    that.setValue( sourceData );
                }

                that.bindValue( zContext );

                if ( that.getValue() !== lastVal ) {
                    that.trig( 'Change' );
                }
            } );
            return that;
        }

        // set source data
        var sourceData = that.form.getFieldSourceData( that.model.name );
        if ( typeof sourceData !== 'undefined' ) {
            that.setValue( sourceData );
        }

        that.bindValue( zContext );

        if ( that.getValue() !== lastVal ) {
            that.trig( 'Change' );
        }
        return that;
    },
    /*
    @rule = {
        dataType: 'string' || 'number',
        maxLen: null,
        minLen: null,
        max: 1000,
        min: 0,
        nullable: true || false,
        regex: /\d+\w+/ig, // return true || 'error msg'
        errPrompt: 'format error',
        remoteCheck: 'checkURL', 
        assocCheck: function( val, zcontext ) {
            return true || 'error tip';
        }
    }
    */
    check: function() {
        if ( this.model.validationEvent === 'none' ) {
            return true;
        }
        var result = this.validate();
        if ( result === true ) {
            this.closeTips();
            return true;
        } else {
            this.showTips( result, 'error' );
            return false;
        }
    },
    validate: function() {
        var rule = this.model.inputRule;
        if ( !rule ) return true;
        var val = this.getValue();
        if ( !val || ( val instanceof Array && val.length === 0 ) ) {
            if ( rule.nullable ) {
                return true;
            } else {
                return rule.nullablePrompt || locale('nullable');
            }
        }
        if ( typeof val === 'object' ) {
            return true;
        } else if ( this.model.dataType === 'string' ) {
            if ( rule.maxLen && val.length > rule.maxLen ) {
                return locale( 'maxLen', { length: rule.maxLen } );
            }
            if ( rule.minLen && val.length < rule.minLen ) {
                return locale( 'minLen', { length: rule.minLen } );
            }
        } else if ( this.model.dataType === 'number' ) {
            var number = parseFloat( val );
            if ( (number + '') == 'NaN' ) {
                return locale( 'number' );
            }
            if ( rule.max && number > rule.max ) {
                return locale( 'max', { number: rule.maxLen } );
            }
            if ( rule.min && number < rule.min ) {
                return locale( 'min', { number: rule.minLen } );
            }
        }
        if ( rule.regex ) {
            try {
                if ( !( new Function( 'return ' + rule.regex + ';' ) )().test( val ) ) {
                    return rule.errPrompt || locale( 'format' );
                }
            } catch ( e ) {
                alert( locale( 'regexError', { regex: rule.regex } ) );
            }
        }


        if ( rule.customValidationFunc ) {
            var validFunc
            try {
                validFunc = eval('(' + rule.customValidationFunc + ')');
            } catch (e) {
                alert('custom validation function is invalid.');
                return true;
            }
            return validFunc( val, this.model.form.getData(), this );
        }
        return true;
    },
    showTips: function( promptText, type ) {
        if ( !this.$tips ) {
            var self = this;
            this.$tips = $( '<div>' )
                .addClass('input-tips');
            var width = this.$container.width()
            var height = this.$container.height();

            var tipPos = this.model.tipPos;
            if ( tipPos === 'left' ) {
                this.$tips.css( {
                    right: width - 2,
                    top: 2,
                    textAlign: 'right'
                } ).appendTo(this.$container);
            } else if ( tipPos === 'top' ) {
                this.$tips.css( {
                    top: '-20px',
                    left: 0,
                } ).prependTo(this.$container);
            } else if ( tipPos === 'bottom' ) {
                this.$tips.css( {
                    // position: 'relative',
                    left: 0,
                    bottom: '-20px'
                } ).appendTo(this.$container);
            } else {
                this.$tips.css( {
                    left: width - 2,
                    top: 0,
                    textAlign: 'left'
                } ).appendTo(this.$container);
            }
        }
        this.$tips.html( promptText )
            .removeClass( 'ui-state-default' )
            .removeClass( 'ui-state-hover' )
            .removeClass( 'ui-state-error' )
            .removeClass( 'ui-state-active' )
            .addClass( 'ui-state-' + type )
            .show( 100 );
        return this;
    },
    closeTips: function() {
        if ( this.$tips ) {
            this.$tips.hide( 100 );
        }
        return this;
    },
    focus: function() {
        this.$inp.focus();
        this.trig( 'Focus' );
        return this;
    },
    disable: function() {
        this.$mask = $( '<div>' )
                .css( {
                    position: 'absolute', 
                    zIndex: 9999, 
                    top: 0,
                    left: 0,
                    width: this.$container.parent().width(), 
                    height: this.$container.parent().height()
                } ).appendTo( this.$container.addClass( 'ui-state-disabled' ) );
        return this;
    },
    enable: function() {
        if ( this.$mask ) {
            this.$mask.remove();
        }
        this.$container.removeClass( 'ui-state-disabled' );
        return this;
    },
    readonly: function( readonly ) {
        var that = this;
        if ( readonly ) {
            this.$mask = $( '<div tabindex="0">' )
                    .css( {
                        position: 'absolute', 
                        zIndex: 1, 
                        top: 0,
                        left: 0,
                        width: this.$container.width(), 
                        height: this.$container.height()
                    } )
                    .on( 'focus', function() {
                        that.trig('Focus');
                    } )
                    .on( 'blur', function() {
                        that.trig('Blur');
                    } )
                    .appendTo( this.$container )

        } else if ( this.$mask ) {
            this.$mask.remove();
        }
        return this;
    },
    hide: function() {
        this.$container.hide();
    },
    show: function() {
        this.$container.show();
    },
    trig: function( eventName ) {

        if ( eventName === 'Focus' ) {
            this.form.setLastFocusInputName( this.model.name );
        }

        if ( eventName === 'Assist' ) {
            this.form.trigInputEvent( this.model.name, 'Assist' );
            return;
        }

        var h = this.eventHandlers[ eventName.toLowerCase() ];
        if ( typeof h == 'function' ) {
            h.apply( this, [this] );
        }
        if ( this.model.trigWindowEvent ) {
            this.form.trigInputEvent( this.model.name, eventName );
        }
        if ( eventName === 'Change' ) {
            this.form.linkage( this.model.name );
        }
    }
} );

module.exports = InputBase;


//////////////////
// WEBPACK FOOTER
// ./src/input-factory/base/index.js
// module id = 9
// module chunks = 0